import React from 'react'
import { Button } from '@mui/material'
import {
  QuizDispatchContext,
  QuizStoreContext,
} from '../../contexts/quizContext'

const DebugInfo: React.FC = () => {
  const reduceQuizData = React.useContext(QuizDispatchContext)
  const { quizResults, artStyleData } = React.useContext(QuizStoreContext)
  // const _onClick = () => {}

  const categoryBreakdown = Object.entries(artStyleData).reduce(
    (accu, [key, value]) => {
      const [category, feature] = key.split('>')
      return {
        ...accu,
        [category]: {
          ...accu[category],
          [feature]: value ? Math.round(value * 100) / 100 : 0,
        },
      }
    },
    {},
  )

  return (
    <div className='Quiz-debug-window' style={{ pointerEvents: 'none' }}>
      <ul>
        {Object.entries(quizResults).map(([category, feature], idx) => (
          <li key={idx} style={{ lineBreak: 'anywhere' }}>
            <b>
              {category}:{feature}
            </b>
            {JSON.stringify(categoryBreakdown[category])
              .replaceAll('"', '')
              .replaceAll(',', ', ')
              .replaceAll('fiction', 'fic')}
          </li>
        ))}
      </ul>
      <Button
        variant='contained'
        color='primary'
        style={{ pointerEvents: 'all' }}
        onClick={() => reduceQuizData({ type: 'reset_quiz' })}>
        Reset data
      </Button>
    </div>
  )
}

export default DebugInfo
